module.exports = __webpack_public_path__ + "img/icon-user-active.3386a9ee.svg";